// --- Import Model --- //
import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import ElementUI from "element-ui";
import nprogress from "nprogress";
import VueResource from "vue-resource";
import echarts from "echarts";
import httpRouter from "utils/javascript/router";
import VueAMap from "vue-amap";
import App from "./app.vue";

// --- Import Css --- //
// import 'element-ui/lib/theme-chalk/index.css';
import "./style/element-variables.scss";
import "nprogress/nprogress.css";

// --- Import App --- //
import store from "./vuex/store";
import Router from "./router/router";
import components from "./components";

// --- 自定义插件 --- //
import utils from "./utils/javascript/utils";
import filters from "./utils/javascript/filters";
// --- 公用JS --- //
import "../env";
import "./utils/javascript/common.js";
import "./utils/javascript/download.js";
// --- 拦截器 --- //
import "./utils/javascript/intercept.js";
// --- 公用LESS --- //
import "./style/common.less";
// --- 全局注册组件/插件 --- //
Vue.use(Vue => {
  const plugin = {
    httpRouter,
    VueRouter,
    Vuex,
    ElementUI,
    components,
    utils,
    filters,
    VueResource,
    echarts,
    VueAMap
  };
  Object.keys(plugin).forEach(key => {
    Vue.use(plugin[key]);
  });
});

// --- 关闭控制台生产环境警告 --- //
Vue.config.productionTip = false;

Vue.http.options.emulateHTTP = false;
// true: content-type 为 form-data格式
// false: content-type 为 application/json格式
Vue.http.options.emulateJSON = false;

// --- 注册路由 --- //
// 注意：如果要去掉"#"，需要用history模式，但在这种模式下需要服务器支持
// 如果直接加，则会出现打包404的情况，原因在于路由为动态加载，
// 但是刷新的时候这个路由文件并没有加载，因此会去寻找服务器端资源，没有找到就会返回404。
const router = new VueRouter({
  routes: Router
});

// --- beforeRouter --- //
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  nprogress.start();
  next();
});

// ---afterRouter --- //
router.afterEach(() => {
  nprogress.done();
});

// --- 实例化Vue --- //
const VueThat = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default VueThat;
